import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";
import { cn } from "../../lib/utils";

export const EnhancedTabs = ({
  children,
  value,
  onValueChange,
  className,
  ...props
}) => {
  return (
    <Tabs
      value={value}
      onValueChange={onValueChange}
      className={className}
      {...props}
    >
      {children}
    </Tabs>
  );
};

export const EnhancedTabsList = ({
  children,
  className,
  variant = "full", // "full" for full-width grid, "compact" for left-aligned compact
  gridCols = 3,
  ...props
}) => {
  const baseClasses =
    variant === "full"
      ? `grid w-full grid-cols-${gridCols}`
      : "inline-flex w-auto";

  return (
    <TabsList className={cn(baseClasses, className)} {...props}>
      {children}
    </TabsList>
  );
};

export const EnhancedTabsTrigger = ({
  children,
  icon: Icon,
  value,
  className,
  ...props
}) => {
  return (
    <TabsTrigger
      value={value}
      className={cn("flex items-center gap-3", className)}
      {...props}
    >
      {Icon && <Icon className="h-4 w-4" />}
      {children}
    </TabsTrigger>
  );
};

export const EnhancedTabsContent = TabsContent;
